if (!window.customElements.get('evo-trip-form')) {
  class EvoTripForm extends HTMLElement {
    constructor() {
      super();
      this.evoTripVariantPicker = document.querySelector('[data-evo-trip-variant-picker]');
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.formSubmitButton = this.querySelector('button[type="submit"]');
      this.selectedVariant = this.querySelector('[data-evo-trip-form-selected-variant]');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.addTravelerButton = this.querySelector('[data-evo-trip-form-add-traveler]');
      this.travelerDetails = this.querySelector('[data-evo-trip-form-traveler-details]');
      this.questionsTextarea = this.querySelector('[data-questions-textarea]');
      this.questionsTextareaCounter = this.querySelector('[data-questions-textarea-counter]');
      this.travelerCount = 1;
      this.summaryTravelers = this.querySelector('[data-evo-trip-form-summary-travelers]');
      this.summaryTotalPrice = this.querySelector('[data-evo-trip-form-summary-total-price]');
      this.summaryVariantPrice = this.querySelector('[data-evo-trip-form-summary-variant-price]');
      this.variantPriceInt = 0;
      this.variantInventory = 0;
    }

    connectedCallback() {
      this.form.addEventListener('submit', (event) => this.submitForm(event));

      document.addEventListener('keyup', (event) => {
        if (event.code !== 'Escape') {
          return;
        }
        this.close();
      });

      if (this.questionsTextarea) {
        this.questionsTextarea.addEventListener('keyup', () => {
          this.questionsTextareaCounter.innerText = `${this.questionsTextarea.value.length}/300`;
        });
      }

      if (this.addTravelerButton) {
        this.addTravelerButton.addEventListener('click', () => this.addTraveler(true, this.travelerCount + 1));
      }

      this.addEventListener('click', (event) => {
        if (!event.target.hasAttribute('data-evo-trip-form-remove-traveler')) return;
        this.removeTraveler(event.target.getAttribute('data-evo-trip-form-remove-traveler'));
      });

      this.addEventListener('change', (event) => {
        if (!event.target.hasAttribute('data-evo-trip-form-type-select')) return;

        const selectWrapper = event.target.closest('[data-evo-trip-form-type-select-wrapper]');
        const soloDisclaimer = selectWrapper?.querySelector('[data-evo-trip-form-solo-disclaimer]');

        if (!soloDisclaimer) return;

        if (event.target.value === window.evoTripForm.soloTravelerOwnRoom) {
          soloDisclaimer.classList.remove('hidden');
        } else {
          soloDisclaimer.classList.add('hidden');
        }
      });

      this.selectFirstVisibleVariant();
      this.setSelectedVariant();
      this.buildTravelerInputs();
    }

    open() {
      this.scrollPosition = window.scrollY;
      this.classList.add('active');

      this.setSelectedVariant();

      setTimeout(() => {
        document.body.classList.add('overflow-hidden', 'fixed', 'h-screen', 'w-full', 'no-smooth-scroll');
        document.querySelector('html').classList.add('no-smooth-scroll');

        if (typeof window.trapFocus === 'function') {
          window.trapFocus(this);
        }
      }, 400);
    }

    close() {
      document.body.classList.remove('overflow-hidden', 'fixed', 'h-screen', 'w-full');
      window.scrollTo(0, this.scrollPosition);
      this.classList.remove('active');

      setTimeout(() => {
        document.body.classList.remove('no-smooth-scroll');
        document.querySelector('html').classList.remove('no-smooth-scroll');

        if (typeof window.removeTrapFocus === 'function') {
          window.removeTrapFocus();
        }
      }, 400);
    }


    addTraveler(increaseCount, index) {
      const nextTravelerCount = increaseCount ? this.travelerCount + 1 : this.travelerCount;

      if (nextTravelerCount > this.variantInventory) {
        return;
      }

      if (increaseCount) {
        this.travelerCount += 1;
      }

      const newElement = document.createElement('div');

      newElement.setAttribute('data-traveler', index);

      newElement.innerHTML = `
        <div class="border-b border-light-gray-3 mb-5" data-evo-trip-form-traveler>
          <div class="flex justify-between">
            <h2 class="heading-xxs mb-5" data-evo-trip-form-traveler-heading>
              ${window.evoTripForm.traveler} ${index}
            </h2>

            ${
              index > 1
                ? `
              <button
                class="flex gap-1 items-center text-sm"
                type="button"
                data-evo-trip-form-remove-traveler="${index}"
              >
                <svg class="pointer-events-none" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.77899 0.32373H6.82149C7.11399 0.32373 7.36649 0.32373 7.57524 0.338106C7.79524 0.353106 8.01524 0.386231 8.23212 0.476231C8.72213 0.679352 9.1115 1.06873 9.31462 1.55873C9.40462 1.77561 9.43775 1.99561 9.45275 2.21561C9.45525 2.25061 9.45712 2.28686 9.459 2.32374H12.1334C12.5015 2.32374 12.8003 2.62249 12.8003 2.99062C12.8003 3.35875 12.5015 3.6575 12.1334 3.6575H11.4453L11.0259 9.74633C10.9803 10.4063 10.9422 10.952 10.8659 11.3913C10.7865 11.8501 10.6547 12.2625 10.3753 12.6232C10.1996 12.8501 9.98839 13.0469 9.75028 13.2063C9.37153 13.46 8.9509 13.5638 8.48778 13.6113C8.04403 13.6575 7.49715 13.6575 6.83529 13.6575H6.76529C6.10342 13.6575 5.55591 13.6575 5.11281 13.6113C4.64968 13.5638 4.22906 13.46 3.8503 13.2063C3.61155 13.0469 3.40093 12.85 3.22531 12.6232C2.94593 12.2625 2.81406 11.8501 2.73406 11.3913C2.65781 10.9519 2.62031 10.4063 2.57468 9.74633L2.15531 3.6575H1.46718C1.09905 3.6575 0.800293 3.35875 0.800293 2.99062C0.800293 2.62249 1.09905 2.32374 1.46718 2.32374H4.14159C4.14346 2.28686 4.14534 2.25061 4.14784 2.21561C4.16284 1.99561 4.19596 1.77561 4.28596 1.55873C4.48908 1.06873 4.87846 0.679352 5.36846 0.476231C5.58534 0.386231 5.80534 0.353106 6.02535 0.338106C6.2341 0.32373 6.4865 0.32373 6.77899 0.32373ZM5.47712 2.32374H8.12337C8.12337 2.31811 8.12274 2.31249 8.12274 2.30624C8.11212 2.15436 8.09462 2.09686 8.08274 2.06873C8.01524 1.90561 7.88524 1.77561 7.72212 1.70811C7.69462 1.69623 7.63649 1.67873 7.48461 1.66811C7.32649 1.65748 7.12024 1.65748 6.80024 1.65748C6.48024 1.65748 6.27398 1.65748 6.11587 1.66811C5.96399 1.67873 5.90587 1.69623 5.87837 1.70811C5.71524 1.77561 5.58524 1.90561 5.51774 2.06873C5.50587 2.09686 5.48837 2.15436 5.47774 2.30624C5.47774 2.31249 5.47712 2.31811 5.47712 2.32374ZM3.49151 3.65749L3.90276 9.61943C3.95088 10.3232 3.98463 10.8001 4.04776 11.1632C4.10901 11.5144 4.18651 11.6869 4.27963 11.8069C4.36713 11.9201 4.47275 12.0188 4.59213 12.0988C4.71776 12.1832 4.89587 12.2488 5.25026 12.2851C5.61652 12.3232 6.09463 12.3238 6.80027 12.3238C7.5059 12.3238 7.98402 12.3232 8.35027 12.2851C8.70464 12.2488 8.88277 12.1832 9.0084 12.0988C9.12778 12.0188 9.2334 11.9201 9.3209 11.8069C9.41403 11.6869 9.49152 11.5144 9.55277 11.1632C9.61527 10.8001 9.64902 10.3232 9.69777 9.61943L10.109 3.65749H3.49151Z" fill="currentColor"/>
                </svg>

                <span class="underline pointer-events-none">
                  ${window.evoTripForm.remove}
                </span>
              </button>
            `
                : ''
            }
          </div>

          <div class="input-wrap mb-5">
            <label for="traveler-${index}-first-name">
              ${window.evoTripForm.firstName}
            </label>

            <div class="input-field-wrap">
              <input
                type="text"
                name="properties[Traveler ${index} First Name]"
                id="traveler-${index}-first-name"
                required
                data-error-message="This input is required"
                placeholder="${window.evoTripForm.firstName}"
              >
            </div>
          </div>

          <div class="input-wrap mb-5">
            <label for="traveler-${index}-last-name">
              ${window.evoTripForm.lastName}
            </label>

            <div class="input-field-wrap">
              <input
                type="text"
                name="properties[Traveler ${index} Last Name]"
                id="traveler-${index}-last-name"
                required
                data-error-message="This input is required"
                placeholder="${window.evoTripForm.lastName}"
              >
            </div>
          </div>

          <div class="select-wrap mb-5">
            <label for="traveler-${index}-gender">
              ${window.evoTripForm.gender}
            </label>

            <select
              id="traveler-${index}-gender"
              name="properties[Traveler ${index} Gender]"
              required
            >
              <option value="${window.evoTripForm.male}">
                ${window.evoTripForm.male}
              </option>
              <option value="${window.evoTripForm.female}">
                ${window.evoTripForm.female}
              </option>
              <option value="${window.evoTripForm.other}">
                ${window.evoTripForm.other}
              </option>
            </select>
          </div>

          <div class="input-wrap mb-5">
            <label for="traveler-${index}-birthdate">
              ${window.evoTripForm.birthdate}
            </label>

            <div class="input-field-wrap relative">
              <date-input>
                <input
                  type="text"
                  id="traveler-${index}-birthdate"
                  name="properties[Traveler ${index} Birthdate]"
                  required
                  maxlength="10"
                />
              </date-input>
            </div>
          </div>

          <div class="input-wrap mb-5">
            <label for="traveler-${index}-phone-number">
              ${window.evoTripForm.phoneNumber}
            </label>

            <div class="input-field-wrap">
              <input
                type="tel"
                name="properties[Traveler ${index} Phone Number]"
                id="traveler-${index}-phone-number"
                required
                data-error-message="This input is required"
                placeholder="${window.evoTripForm.phoneNumber}"
              >
            </div>
          </div>

          <div class="input-wrap mb-5">
            <label for="traveler-${index}-email">
              ${window.evoTripForm.email}
            </label>

            <div class="input-field-wrap">
              <input
                type="email"
                name="properties[Traveler ${index} Email]"
                id="traveler-${index}-email"
                required
                data-error-message="This input is required"
                placeholder="${window.evoTripForm.email}"
              >
            </div>
          </div>

          <div class="mb-5" data-evo-trip-form-type-select-wrapper>
            <div class="select-wrap">
              <label for="traveler-${index}-travel-type">
                ${window.evoTripForm.howAreYouTraveling}
              </label>

              <select
                id="traveler-${index}-travel-type"
                name="properties[Traveler ${index} Travel Type]"
                data-evo-trip-form-type-select
                required
              >
                <option value="${window.evoTripForm.soloTravelerOwnRoom}">
                  ${window.evoTripForm.soloTravelerOwnRoom}
                </option>
                <option value="${window.evoTripForm.soloTravelerShareRoom}">
                  ${window.evoTripForm.soloTravelerShareRoom}
                </option>
                <option value="${window.evoTripForm.withAPartnerSameBed}">
                  ${window.evoTripForm.withAPartnerSameBed}
                </option>
                <option value="${window.evoTripForm.withAPartnerTwoBeds}">
                  ${window.evoTripForm.withAPartnerTwoBeds}
                </option>
              </select>
            </div>

            <div class="text-sm text-dark-gray-1 mt-2" data-evo-trip-form-solo-disclaimer>
              <span>
                ${window.evoTripForm.soloDisclaimer}
              </span>
            </div>
          </div>

          <div class="mb-5">
            <div class="check-wrap mb-3">
              <input
                id="traveler-${index}-arriving-sooner"
                type="checkbox"
                name="properties[Traveler ${index} Arriving Sooner]"
              >

              <label for="traveler-${index}-arriving-sooner">
                ${window.evoTripForm.willBeArrivingSooner}
              </label>
            </div>

            <div class="check-wrap">
              <input
                id="traveler-${index}-needs-rental-equipment"
                type="checkbox"
                name="properties[Traveler ${index} Needs Rental Equipment]"
              >

              <label for="traveler-${index}-needs-rental-equipment">
                ${window.evoTripForm.needsRentalEquipment}
              </label>
            </div>
          </div>
        </div>
      `;

      this.travelerDetails.appendChild(newElement);


      this.summaryTravelers.innerText = `x${this.travelerCount}`;
      this.setPrices();
    }

    removeTraveler(index) {
      const travelerElement = document.querySelector(`[data-traveler="${index}"]`);

      if (!travelerElement) return;

      travelerElement.remove();
      this.travelerCount -= 1;

      if (index < this.travelerCount + 1) {
        this.updateTravelerIndexes();
      }

      this.summaryTravelers.innerText = `x${this.travelerCount}`;
      this.setPrices();
    }

    updateTravelerIndexes() {
      const travelerElements = this.querySelectorAll('[data-traveler]');

      travelerElements.forEach((travelerElement, index) => {
        const newIndex = index + 1;
        const heading = travelerElement.querySelector('[data-evo-trip-form-traveler-heading]');
        const labels = travelerElement.querySelectorAll('label');
        const inputs = travelerElement.querySelectorAll('input');
        const selects = travelerElement.querySelectorAll('select');

        travelerElement.setAttribute('data-traveler', newIndex);

        heading.innerText = heading.innerText.replace(/\d+/g, newIndex);

        labels.forEach((label) => {
          label.setAttribute('for', label.getAttribute('for').replace(/\d+/g, newIndex));
        });

        inputs.forEach((input) => {
          input.setAttribute('id', input.getAttribute('id').replace(/\d+/g, newIndex));
          input.setAttribute('name', input.getAttribute('name').replace(/\d+/g, newIndex));
        });

        selects.forEach((select) => {
          select.setAttribute('name', select.getAttribute('name').replace(/\d+/g, newIndex));
        });
      });
    }

    buildTravelerInputs() {
      for (let index = 1; index < this.travelerCount + 1; index++) {
        this.addTraveler(false, index);
      }
    }

    selectFirstVisibleVariant() {
      const labels = this.evoTripVariantPicker.querySelectorAll('label');

      if (!labels.length) return;

      const firstAvailableVariant = Array.from(labels).find((label) => label.classList.contains('available'));

      if (!firstAvailableVariant) return;

      firstAvailableVariant.click();
    }

    setSelectedVariant() {
      const checkedInput = this.evoTripVariantPicker.querySelector('input:checked');

      if (!checkedInput) return;

      const variantBox = checkedInput.closest('label').querySelector('[data-evo-trip-variant-box]');

      if (!variantBox) return;

      this.variantPriceInt = parseInt(variantBox.getAttribute('data-variant-price'));
      this.variantInventory = parseInt(variantBox.getAttribute('data-variant-inventory'));
      this.selectedVariant.innerHTML = variantBox.innerHTML;
      this.variantIdInput.value = checkedInput.value;

      if (this.hasAttribute('data-cnstrc-item-variation-id')) {
        const variationId = variantBox.getAttribute('data-variant-sku') || variantBox.getAttribute('data-variant-id');
        this.setAttribute('data-cnstrc-item-variation-id', variationId);
      }

      if (this.hasAttribute('data-cnstrc-item-price')) {
        this.setAttribute('data-cnstrc-item-price', (Number(variantBox.getAttribute('data-variant-price')) / 100).toFixed(2));
      }

      this.setPrices();
    }

    setPrices() {
      this.summaryVariantPrice.innerText = `${window.formatMoney(this.variantPriceInt)}/pp`;
      this.summaryTotalPrice.innerText = window.formatMoney(this.variantPriceInt * this.travelerCount);
    }

    submitForm(event) {
      event.preventDefault();

      this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-adding-text');
      this.formSubmitButton.setAttribute('disabled', '');
      this.formSubmitButton.setAttribute('aria-disabled', 'true');
      this.formSubmitButton.setAttribute('aria-busy', 'true');

      const formData = new FormData(this.form);

      const properties = {};

      formData.forEach((value, key) => {
        if (key.indexOf('properties') === -1) return;
        const formattedKey = key.replace('properties[', '').replace(']', '');

        if (value == 'on') {
          properties[formattedKey] = 'Yes';
        } else {
          properties[formattedKey] = value;
        }
      });

      if (!formData.get('id')) {
        this.resetSubmitButton();
        return;
      }

      const postBody = {
        items: [
          {
            id: formData.get('id'),
            quantity: this.travelerCount,
            properties,
          },
        ],
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(postBody),
        credentials: 'same-origin',
      })
        .then((response) => {
          if (response.ok) {
            const sideCart = document.querySelector('side-cart');

            this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-success-text');

            this.updateCartBubbles();

            if (sideCart) {
              sideCart.renderContents();
            }

            this.formSubmitButton.removeAttribute('aria-busy');
            this.formSubmitButton.removeAttribute('disabled');
            this.formSubmitButton.removeAttribute('aria-disabled');

            setTimeout(() => {
              this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-available-text');

              if (sideCart) {
                sideCart.open();
                this.close();
              }
            }, 1500);
          } else {
            return response.json().then((err) => {
              console.error('Cart add error:', err);

              this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-error-text');

              setTimeout(() => {
                this.resetSubmitButton();
              }, 1500);
            });
          }
        })
        .catch((error) => {
          console.error(error);

          this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-error-text');

          setTimeout(() => {
            this.resetSubmitButton();
          }, 1500);
        });
    }

    resetSubmitButton() {
      this.formSubmitButton.innerText = this.formSubmitButton.getAttribute('data-available-text');
      this.formSubmitButton.removeAttribute('aria-busy');
      this.formSubmitButton.removeAttribute('disabled');
      this.formSubmitButton.removeAttribute('aria-disabled');
    }

    async updateCartBubbles() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        if (response.ok) {
          const cart = await response.json();
          const cartBubbles = document.querySelectorAll('[data-cart-bubble]');

          cartBubbles.forEach((bubble) => {
            bubble.classList.remove('hidden');
            bubble.textContent = cart.item_count;

            if (cart.item_count > 0) {
              bubble.style.display = '';
            } else {
              bubble.style.display = 'none';
            }
          });
        }
      } catch (error) {
        console.error('Failed to update cart bubbles:', error);
      }
    }
  }

  window.customElements.define('evo-trip-form', EvoTripForm);
}

if (!window.customElements.get('evo-trip-form-close')) {
  class EvoTripFormClose extends HTMLElement {
    constructor() {
      super();
      this.evoTripForm = document.querySelector('evo-trip-form');
      this.button = this.querySelector('[data-evo-trip-form-close]');
    }

    connectedCallback() {
      if (!this.button || !this.evoTripForm) return;
      this.button.addEventListener('click', () => this.evoTripForm.close());
    }
  }

  window.customElements.define('evo-trip-form-close', EvoTripFormClose);
}

if (!window.customElements.get('evo-trip-form-toggle')) {
  class EvoTripFormToggle extends HTMLElement {
    constructor() {
      super();
      this.evoTripForm = document.querySelector('evo-trip-form');
      this.button = this.querySelector('[data-evo-trip-form-toggle]');
    }

    connectedCallback() {
      if (!this.button || !this.evoTripForm) return;
      this.button.addEventListener('click', () => this.evoTripForm.open());
      if (this.evoTripForm.variantInventory == 0) {
        this.disableButton();
      }
    }

    disableButton() {
      this.button.disabled = true;
      this.button.setAttribute('aria-disabled', 'true');
      this.button.textContent = this.button.getAttribute('data-soldout-text');
    }
  }

  window.customElements.define('evo-trip-form-toggle', EvoTripFormToggle);
}


if (!window.customElements.get('date-input')) {
  class DateInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('input');

      if (this.input) {
       this.input.addEventListener('keyup', () => this.formatDate());
      }
    }

    formatDate() {
      // Remove all non-numeric characters
      const formattedValue = this.input.value.replace(/\D+/g, '');;

      const month = formattedValue.slice(0, 2);
      const day = formattedValue.slice(2, 4);
      const year = formattedValue.slice(4, 8);

      this.input.value = `${month}${day ? `/${day}` : ''}${year ? `/${year}` : ''}`;
    }
  }

  window.customElements.define('date-input', DateInput);
}
